import React from "react";

const ImageSourceCaption = ({ sourceText }) => {
    let caption = "Image Source: Unknown"
    if (sourceText) {
        caption = "Image Source: " + sourceText
    }
    return (
        <>
            {sourceText && sourceText === "dall-e-3" &&
                <figcaption>
                    AI generated image using <a href="https://openai.com/index/dall-e-3/" target="_blank">OpenAI DALL·E 3</a>.
                </figcaption>
            }
            {sourceText && sourceText === "microsoft-copilot" &&
                <figcaption>
                    AI generated image using <a href='https://copilot.microsoft.com/images/create' target='_blank'>Microsoft Copilot</a>.
                </figcaption>
            }
            {sourceText && sourceText === "author" &&
                <figcaption>
                    Image Source: Prepared by Author
                </figcaption>
            }
            {sourceText && sourceText != "dall-e-3" && sourceText != "microsoft-copilot" && sourceText != "author" &&
                <figcaption>
                    Image Source: {sourceText}
                </figcaption>
            }
        </>
    )
};

export default ImageSourceCaption;